const videoPopup = () => {

    const videoLink     = $('.js-video-link');

    if ( videoLink.length ) {
        videoLink.magnificPopup({
            type: 'inline',
            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close"><svg class="i"><use xlink:href="#close-modal-white"/></svg></button>',
            tClose: 'Закрыть (Esc)',
            midClick: true,
            removalDelay: 200,
            callbacks: {
                beforeOpen: function beforeOpen() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                    $('body').addClass(this.st.el.attr('data-overlay'));
                    $("#video-player").on("contextmenu", function() {
                        return false;
                    });
                },
                open: function () {
                    $('#video-player').find('source').attr('src', this.st.el.attr('data-url'));
                    document.getElementById('video-popup').load();
                },
                close: function close() {
                    $('#video-popup').trigger('pause');
                    $('body').removeClass(this.st.el.attr('data-overlay'));
                }
            }
        });

    }

}